<form [formGroup]="formGroupRangoOpciones">
    <div class="row">
        <div class="col-4">
            <div class="mb-3">
                <label class="form-label" for="desde">Desde</label>
                <input type="number" id="desde" class="form-control" formControlName="desde">
            </div>
        </div>
        <div class="col-4">
            <div class="mb-3">
                <label class="form-label" for="hasta">Hasta</label>
                <input type="number" id="hasta" class="form-control" formControlName="hasta">
            </div>
        </div>
        <div class="col-4">
            <div class="mb-3">
                <label class="form-label" for="opciones">Opciones</label>
                <input type="number" id="opciones" class="form-control" formControlName="opciones">
            </div>
        </div>
    </div>
</form>
<h4>O</h4>
<form [formGroup]="formGroupRangoIncremento">
    <div class="row">
        <div class="col-4">
            <div class="mb-3">
                <label class="form-label" for="desde">Desde</label>
                <input type="number" id="desde" class="form-control" formControlName="desde">
            </div>
        </div>
        <div class="col-4">
            <div class="mb-3">
                <label class="form-label" for="hasta">Hasta</label>
                <input type="number" id="hasta" class="form-control" formControlName="hasta">
            </div>
        </div>
        <div class="col-4">
            <div class="mb-3">
                <label class="form-label" for="incremento">Incremento</label>
                <input type="number" id="incremento" class="form-control" formControlName="incremento">
            </div>
        </div>
    </div>
</form>
<div class="row mb-2">
    <div class="col-12">
        Valores
        <div class="row">
            <div class="col d-flex justify-content-center">
                <div *ngFor="let valor of valores" class="recuadro-item-valor">{{valor}}</div>
            </div>
        </div>
    </div>
</div>
